<div
  class="card product-card h-100"
  [ngClass]="product.is_discount ? 'card-discount' : ''"
>
  <div class="card-image">
    <a
      [sRouterLink]="[
        'product',
        product.type_id === ProductType.Bundle ? product.url_key[0] : product.url_key,
      ]"
      title="{{
        product.type_id === ProductType.Bundle ? product.name[0] : product.name
      }}"
    >
      <img
        [src]="product.image_small || 'assets/images/product-placeholder.webp'"
        width="218"
        height="225"
        [alt]="product.type_id === ProductType.Bundle ? product.name[0] : product.name"
      />
    </a>

    @if (product.discountPercent) {
      <span class="badge badge-secondary">%</span>
    }

    @if (isWishlistType) {
      <mat-icon class="close-icon" (click)="deleteProductFromWishList()">close</mat-icon>
    }
  </div>

  <div class="card-body">
    <h2 class="card-title" id="product-id-{{ product.entity_id }}">
      <a
        [sRouterLink]="[
          'product',
          product.type_id === ProductType.Bundle ? product.url_key[0] : product.url_key,
        ]"
        [innerHtml]="
          product.type_id === ProductType.Bundle ? product.name[0] : product.name
        "
      ></a>
    </h2>

    <div class="card-price">
      <span [ngClass]="product.is_discount ? 'special-price' : 'regular-price'">
        <app-currency></app-currency>
        <app-price [price]="product.finalPrice"></app-price>
      </span>

      @if (product.is_discount) {
        <span class="original-price">
          <label translate>Norm.</label> <app-currency></app-currency>
          <app-price [price]="product.regularPrice"></app-price>
        </span>
      }

      @if (product.price) {
        <span class="original-price">
          <app-currency></app-currency>
          <span>{{ product.price | noComma }}</span>
        </span>
      }

      <div class="card-footer">
        @if (isConfigurable()) {
          <a [sRouterLink]="['product', product.url_key]" class="btn-view-more">
            <span class="view-more" translate>View more</span>
          </a>
        } @else {
          @if (isWishlistType) {
            <app-speedy-qty
              [qty]="qty"
              (qtyChange)="onQtyChange($event)"
            ></app-speedy-qty>
          }
          <mat-icon
            class="card-footer__icon add-to-cart"
            svgIcon="basket-plus-outline"
            (click)="addToCart(product)"
          ></mat-icon>
          @if (!isWishlistType) {
            <mat-icon
              class="card-footer__icon add-to-wishlist"
              svgIcon="heart-outline"
              (click)="addProductToWishList(product.entity_id)"
            ></mat-icon>
          }
        }

        @if (loading()) {
          <div class="card-footer__loading">
            <mat-spinner diameter="25"></mat-spinner>
          </div>
        }
      </div>

      <div>
        <app-product-stock-options
          [salableQty]="product.salable_qty"
          [isInStock]="product.stock?.is_in_stock!"
          [stockText]="
            productStockService.isProductOutOfStock(product) ? 'Out of stock' : 'In stock'
          "
        ></app-product-stock-options>
      </div>
    </div>
  </div>
</div>
